// seed.ts - the S15 SEEDED progress read, typed against the real schema. seed.json is the LITERAL output
// of buildDashboard + buildSessionDebrief over the same 3-hand/9-decision fixture the API test asserts
// (dumped by _dump-seed.test.ts, not hand-transcribed). Used as the preview/offline fallback so the app
// renders real engine values when the Worker isn't reachable (headless preview has no Access identity).
import type { ProgressDashboard, SeriesDebrief } from '@postflop/schema';
import seedJson from './seed.json';

export const SEED = seedJson as { dashboard: ProgressDashboard; debrief: SeriesDebrief };
export const SEED_DASHBOARD: ProgressDashboard = SEED.dashboard;
export const SEED_DEBRIEF: SeriesDebrief = SEED.debrief;
